export default __webpack_public_path__ + "aa1ee7076cb199d9254640ba8911a282.svg";